<div #wrapper class="w-full h-full flex flex-col shadow-lg component overflow-hidden">
  @if (breadcrumb) {
    <div>
      <p-breadcrumb [model]="items" [home]="home"/>
    </div>

    @if (title) {
      <div>
        <h1 class="text-2xl mb-4 mx-4 text-surface-800"> {{ title }}</h1>
      </div>
    }
  }

  @if (banner) {
    <div class="px-4 py-2">
      <p-message [severity]="banner.type" [icon]="resolveIcon()">{{ banner.message }}</p-message>
    </div>
  }

  @if (breadcrumb && title) {
    <p-divider/>
  }

  <div class="overflow-hidden min-h-0 flex flex-col flex-1 p-2">
    <ng-content></ng-content>
  </div>
</div>
